import fetchBase from "./fetch-base";

async function POST<T>(url: string, data: any, options: RequestInit = {}) {
  return fetchBase<T>(url, data, {
    ...options,
    method: "POST",
  });
}

export default POST;
